
import { AIPersonality } from "@/components/settings/AIPersonalityPanel";

export const getPersonalityStyle = (aiPersonality: AIPersonality) => {
  switch (aiPersonality) {
    case "ultraterrestrial":
      return "bg-black text-green-400 font-mono";
    case "terrestrial":
      return "bg-gray-900 text-blue-400 font-serif";
    case "passenger":
      return "bg-indigo-950 text-amber-300 font-mono";
    case "static":
      return "bg-zinc-900 text-white font-mono";
    case "librarian":
      return "bg-slate-900 text-teal-300 font-serif";
    case "entity247b":
      return "bg-red-950 text-red-300 font-mono";
    default:
      return "bg-black text-green-400 font-mono";
  }
};
